import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const languages = [
	{ code: "es", name: "Español", flag: "🇨🇴" },
	{ code: "en", name: "English", flag: "🇺🇸" },
];

export function LanguageSwitcher() {
	const { i18n } = useTranslation();

	const handleLanguageChange = (langCode: string) => {
		i18n.changeLanguage(langCode);
	};

	// i18n.language can be "es-CO" or "en-US", so check with startsWith
	const currentLang = i18n.language?.split("-")[0] ?? "es";

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" className="size-9" aria-label="Cambiar idioma">
					<Languages className="size-4" />
					<span className="sr-only">Cambiar idioma</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				{languages.map((lang) => (
					<DropdownMenuItem
						key={lang.code}
						onClick={() => handleLanguageChange(lang.code)}
						className={currentLang === lang.code ? "bg-accent" : ""}
					>
						<span className="mr-2">{lang.flag}</span>
						{lang.name}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
